var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWork = function SvgWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.436 15q-.614 0-1.025-.405A1.36 1.36 0 0 1 0 13.586V5.04q0-.605.411-1.01t1.025-.404h3.897V2.413q0-.604.411-1.008Q6.156 1 6.77 1h2.462q.613 0 1.025.405.41.405.41 1.008v1.212h3.898q.614 0 1.025.405T16 5.039v8.547q0 .605-.411 1.01T14.564 15zm0-.875h13.128a.53.53 0 0 0 .376-.168.51.51 0 0 0 .171-.37V5.038a.51.51 0 0 0-.17-.37.53.53 0 0 0-.377-.169H1.436a.53.53 0 0 0-.376.168.51.51 0 0 0-.171.37v8.548q0 .203.17.37.172.17.377.169m4.786-10.5h3.556V2.413a.5.5 0 0 0-.171-.37.53.53 0 0 0-.376-.168H6.769a.53.53 0 0 0-.376.168.5.5 0 0 0-.17.37z"
  })));
};
export default SvgWork;